import { DateTime } from 'luxon';

export class DeviceIdHelper {
  static generate(): string {
    const { getUserAgentParts, getCodeFromDevice, getCodeFromBrowserInfo } = DeviceIdHelper;

    const { device, browserData } = getUserAgentParts();
    const timestamp = DateTime.now().toMillis();

    return `${getCodeFromDevice(device)}-${getCodeFromBrowserInfo(browserData)}-${timestamp}`;
  }

  static getUserAgentParts(): { device: string; browserData: string } {
    const userAgentParts = navigator.userAgent.split(/[()]/)?.map(part => part?.trim());

    if (!userAgentParts?.length || userAgentParts?.length < 2)
      return { device: 'unknown', browserData: 'unknown' };

    const device = userAgentParts[1];
    const browserData = userAgentParts[userAgentParts.length - 1];
    return { device, browserData };
  }

  static getCodeFromDevice(device: string): number {
    return device.substring(0, 3).charCodeAt(0);
  }

  static getCodeFromBrowserInfo(data: string): number {
    return data.split(' ')[0].charCodeAt(0);
  }
}
